
'use client';

import Link from 'next/link';
import { getCdnUrl } from '@/utils/cdn';
import { FaInstagram, FaFacebook, FaYoutube, FaTiktok } from "react-icons/fa";
import { Button } from '@mui/material'
import { useState } from 'react';
import ModalPoliticaPrivacidade from './ModalPoliticaPrivacidade';
import ModalTermoCondicao from './ModalTermoCondicao';

export default function Footer() {
    const [termoContrato, setTermoContrato] = useState(false);
    const [politicaPrivacidade, setPoliticaPrivacidade] = useState(false);
    
    return (
        <footer className="bg-[#1d1d23] text-white relative z-30 w-full">
            <ModalPoliticaPrivacidade open={politicaPrivacidade} setOpen={setPoliticaPrivacidade}/>
            <ModalTermoCondicao open={termoContrato} setOpen={setTermoContrato}/>

            <div className="transform origin-bottom scale-[0.9] md:scale-[0.95]">
                <div className="py-7 md:px-[8%] px-6">
                    <div className='flex justify-between items-center md:px-20 '>
                        <img
                            src={getCdnUrl("/images/common/logo-footer.webp")}
                            alt="Forbli Logo"
                            width={100}
                            height={92}
                            className=""
                            loading="lazy"
                            decoding="async"
                        />
                        <div className="flex gap-x-2 items-center text-white">
                            <Link href={'https://www.instagram.com/forbliconstrutora/'} target='_blank' aria-label="Instagram">
                                <FaInstagram className='md:w-10 w-8 md:h-10 h-8' />
                            </Link>
                            <Link href={'https://www.facebook.com/forbliconstrutora'} target='_blank' aria-label="Facebook">
                                <FaFacebook className='md:w-10 w-8 md:h-10 h-8' />
                            </Link>
                            <Link href={'https://www.youtube.com/@forbli'} target='_blank' aria-label="YouTube">
                                <FaYoutube className='md:w-10 w-8 md:h-10 h-8' />
                            </Link>
                            <Link href={'https://www.tiktok.com/@forbliconstrutora'} target='_blank' aria-label="TikTok">
                                <FaTiktok className='md:w-10 w-8 md:h-10 h-8' />
                            </Link>
                        </div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 md:gap-x-6 md:gap-y-0 gap-y-16 mt-7">
                        <div>

                        </div>
                        <div className='flex flex-col items-center'>
                            <div>
                                <h3 className="md:text-[22px] text-[14px]  mt-5">Horários de atendimento</h3>
                                <p className="md:text-[16px] text-[14px] mt-2">
                                    Segunda – Sexta:<br />
                                    8h00 às 18h00<br />
                                </p>
                            </div>

                        </div>
                        <div className='flex flex-col items-center'>
                            <div>
                                <h3 className="md:text-[21px] text-[14px] font-semibold">Endereço</h3>
                                <p className="md:text-[16px] text-[14px] mt-2">
                                    Rua João Ribeiro da Fonseca, 122,<br />
                                    Barbacena - MG,<br />
                                    36202-278
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col items-center">
                            <div className='flex flex-col items-start'>
                                <Button onClick={() => setPoliticaPrivacidade(true)}  sx={{ textTransform: 'none', color: '#FFF', p: 1, fontSize: { md: '15px', xs: '12px'}}}>Política de privacidade</Button>
                                <Button onClick={() => setTermoContrato(true)}  sx={{ textTransform: 'none', color: '#FFF', p: 1, fontSize: { md: '15px', xs: '12px'}}}>Termos e Condições</Button>
                            </div>
                        </div>
                    </div>
                    <div className="mt-12 flex justify-center md:h-[300px] h-[160px] w-full">
                        <img
                            src={getCdnUrl("/images/common/footer-cover.webp")}
                            alt="Forbli YouTube Cover"
                            width={1700}
                            height={300}
                            className="md:rounded-[55px] rounded-3xl object-cover"
                            loading="lazy"
                            decoding="async"
                            
                        />
                    </div>
                    <div className="mt-8 flex gap-x-4 justify-center items-center">
                        <div className='flex gap-x-2 items-center '>
                            <p className="md:text-[11px] text-[8px] text-center">
                                Todos os direitos reservados a Forbli © 2025 | Desenvolvido por DataClix.
                            </p>
                            <img
                                src={getCdnUrl("/images/common/logo-getty.webp")}
                                alt="Getty Images"
                                width={22}
                                height={23}
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}